import { render, staticRenderFns } from "./TeacherReport.vue?vue&type=template&id=da5e07fc&scoped=true&"
import script from "./TeacherReport.vue?vue&type=script&lang=js&"
export * from "./TeacherReport.vue?vue&type=script&lang=js&"
import style0 from "./TeacherReport.vue?vue&type=style&index=0&id=da5e07fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e07fc",
  null
  
)

export default component.exports